import Header from "../blocks/header";
import Dashboard from "../blocks/dashboard";
import Toolbar from "@mui/material/Toolbar";
import * as React from "react";
import Copyright from "../blocks/copyright";
import Box from "@mui/material/Box";
import {useNavigate, useParams} from "react-router-dom";
import {useTranslation} from "react-i18next";
import {useEffect, useState} from "react";
import {connect} from "react-redux";
import {getAllVerifyResponse} from "../store/logIn";
import Button from "@mui/material/Button";
import {toast} from "react-toastify";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/Delete";
import {saveSectionReport, messageReset} from "../store/sectionReports";
import {Box as MuiBox, FormControl, InputLabel, MenuItem, Select} from "@mui/material";
import {LocalizationProvider} from "@mui/x-date-pickers/LocalizationProvider";
import {AdapterDayjs} from "@mui/x-date-pickers/AdapterDayjs";
import {DatePicker} from "@mui/x-date-pickers";
import TextField from "@mui/material/TextField";

const SECTION_LABELS = {
    biznes_reja:        'section_biznes_reja',
    kuzgi_qishki:       'section_kuzgi_qishki',
    mehnat_muhofazasi:  'section_mehnat_muhofazasi',
    yongin_xavfsizligi: 'section_yongin_xavfsizligi',
    inventarizatsiya:   'section_inventarizatsiya',
}

const SECTION_CONFIGS = {
    kuzgi_qishki: {
        columns: [
            {key: 'tadbirlar_nomi', label: 'Тадбирлар номи',        width: '40%'},
            {key: 'muddati',        label: 'Муддати',                width: '15%'},
            {key: 'masul_shaxs',    label: 'Масъул шахс',            width: '25%'},
            {key: 'sarf_mablag',    label: 'Сарфланадиган маблағ',   width: '20%'},
        ],
        defaultRows: [
            {tadbirlar_nomi: "Корхона бинолари ва худудини куриб чиқиб таъмирталаб жойларни таъмирдан чиқариш", muddati: '', masul_shaxs: '', sarf_mablag: ''},
            {tadbirlar_nomi: "Корхона худудини ободонлаштириш. Манзарали гуллар экиш", muddati: '', masul_shaxs: '', sarf_mablag: ''},
            {tadbirlar_nomi: "Бинолардаги таъмирталаб ёритгич манбаалари электр симлар ва кабелларни алмаштириш", muddati: '', masul_shaxs: '', sarf_mablag: ''},
            {tadbirlar_nomi: "Ишлаб чиқариш цехларини иссиқлик билан таъминлаш", muddati: '', masul_shaxs: '', sarf_mablag: ''},
        ]
    },
    yongin_xavfsizligi: {
        columns: [
            {key: 'tadbirlar_nomi', label: 'Тадбирлар номи',          width: '40%'},
            {key: 'muddati',        label: 'Муддати',                  width: '15%'},
            {key: 'masul_shaxs',    label: 'Масъул шахс',              width: '25%'},
            {key: 'sarf_mablag',    label: 'Сарфланадиган маблағлар',  width: '20%'},
        ],
        defaultRows: [
            {tadbirlar_nomi: "Ёнғинга қарши ишлатиладиган жавонлар ва ҳовузни таъмирлаш ҳамда уларни жиҳозлар билан тўлдириш", muddati: '', masul_shaxs: '', sarf_mablag: ''},
            {tadbirlar_nomi: "Ёнғин хавфсизлик қоидалари бўйича ишчилар орасида тушунтириш ишларини суҳбат асосида олиб бориш", muddati: '', masul_shaxs: '', sarf_mablag: ''},
            {tadbirlar_nomi: "Туман ёнғинга қарши курашиш масъул шахси билан биргаликда амалий семинар ташкил этиш", muddati: '', masul_shaxs: '', sarf_mablag: ''},
        ]
    },
    mehnat_muhofazasi: {
        columns: [
            {key: 'tadbirlar_nomi', label: 'Тадбирлар номи',       width: '40%'},
            {key: 'muddati',        label: 'Муддати',               width: '15%'},
            {key: 'masul_shaxs',    label: 'Масъул шахс',           width: '25%'},
            {key: 'sarf_mablag',    label: 'Сарфланадиган маблағ',  width: '20%'},
        ],
        defaultRows: [
            {tadbirlar_nomi: "Кийим-кечак билан таъминлаш", muddati: '', masul_shaxs: '', sarf_mablag: ''},
            {tadbirlar_nomi: "Шахсий гигена воситалари билан таъминлаш", muddati: '', masul_shaxs: '', sarf_mablag: ''},
        ]
    },
}

function TableForm({config, rows, setRows}) {
    const {columns} = config

    function updateRow(idx, key, val) {
        setRows(rows.map((r, i) => i === idx ? {...r, [key]: val} : r))
    }

    function addRow() {
        const empty = {}
        columns.forEach(c => { empty[c.key] = '' })
        setRows([...rows, empty])
    }

    function removeRow(idx) {
        if (rows.length <= 1) return
        setRows(rows.filter((_, i) => i !== idx))
    }

    const hasSarf = columns.some(c => c.key === 'sarf_mablag')
    const total = hasSarf
        ? rows.reduce((sum, r) => sum + (parseFloat((r.sarf_mablag || '').replace(/\s/g, '').replace(',', '.')) || 0), 0)
        : null

    return (
        <div style={{overflowX: 'auto', marginBottom: 16}}>
            <table className="table table-bordered" style={{minWidth: 700, borderCollapse: 'collapse'}}>
                <thead>
                <tr style={{background: '#f5f5f5'}}>
                    <th style={{width: '40px', textAlign: 'center', padding: '8px'}}>#</th>
                    {columns.map(c => (
                        <th key={c.key} style={{width: c.width, padding: '8px', textAlign: 'center'}}>{c.label}</th>
                    ))}
                    <th style={{width: '50px'}}/>
                </tr>
                </thead>
                <tbody>
                {rows.map((row, idx) => (
                    <tr key={idx}>
                        <td style={{textAlign: 'center', verticalAlign: 'middle', padding: '4px'}}>{idx + 1}</td>
                        {columns.map(c => (
                            <td key={c.key} style={{padding: '4px', verticalAlign: 'middle'}}>
                                    <textarea
                                        value={row[c.key] || ''}
                                        onChange={e => updateRow(idx, c.key, e.target.value)}
                                        rows={c.key === 'tadbirlar_nomi' ? 3 : 2}
                                        style={{
                                            width: '100%', padding: '6px',
                                            border: '1px solid #ccc', borderRadius: '4px',
                                            resize: 'vertical', fontFamily: 'inherit',
                                            fontSize: '14px', boxSizing: 'border-box',
                                        }}
                                    />
                            </td>
                        ))}
                        <td style={{textAlign: 'center', verticalAlign: 'middle', padding: '4px'}}>
                            <Button size="small" variant="outlined" color="error"
                                    onClick={() => removeRow(idx)} disabled={rows.length <= 1}
                                    sx={{minWidth: '36px', p: '4px'}}>
                                <DeleteIcon fontSize="small"/>
                            </Button>
                        </td>
                    </tr>
                ))}
                {hasSarf && (
                    <tr style={{background: '#fafafa', fontWeight: 'bold'}}>
                        <td colSpan={columns.length} style={{textAlign: 'right', padding: '8px'}}>Жами:</td>
                        <td style={{padding: '8px', textAlign: 'center'}}>
                            {total > 0 ? total.toLocaleString('uz-UZ') : '—'}
                        </td>
                        <td/>
                    </tr>
                )}
                </tbody>
            </table>
            <Button variant="outlined" startIcon={<AddIcon/>} onClick={addRow} size="small">
                + Қатор қўшиш
            </Button>
        </div>
    )
}

function SectionAdd(props) {
    const navigate  = useNavigate()
    const {t}       = useTranslation()
    const params    = useParams()
    const sectionType = params.sectionType
    const pageTitle   = t(SECTION_LABELS[sectionType] || sectionType)

    const [year, setYear]   = useState(new Date())
    const [month, setMonth] = useState('')
    const [monthError, setMonthError] = useState(false)

    const config = SECTION_CONFIGS[sectionType]
    const [rows, setRows] = useState(() => config ? config.defaultRows.map(r => ({...r})) : [])

    const [file, setFile]         = useState('')
    const [fileName, setFileName] = useState('')
    const [text, setText]         = useState('')

    const toBack = () => navigate(-1)

    function prepareUpload(event) {
        const f = event.target.files[0]
        if (f) { setFile(f); setFileName(f.name) }
    }

    function saveFormData(e) {
        e.preventDefault()

        if (!month) { setMonthError(true); return }
        setMonthError(false)

        const yearStr = year
            ? (year.$y || new Date(year).getFullYear()).toString()
            : new Date().getFullYear().toString()

        if (config) {
            props.saveSectionReport({
                section_type: sectionType,
                year: yearStr,
                month: month,
                rows: JSON.stringify(rows),
                text: text,
            })
        } else {
            if (!file) { setFileName('*'); return }
            props.saveSectionReport({
                section_type: sectionType,
                year: yearStr,
                month: month,
                file: file,
                text: text,
            })
        }
    }

    useEffect(() => {
        if (props.message === true) {
            toast.success(t('save_success'), {theme: 'colored'})
            navigate(`/sections/${sectionType}/`)
        } else if (props.message === 'error') {
            toast.error(t('save_error'), {theme: 'colored'})
            props.messageReset()
        }
    }, [props.message])

    return (
        <div>
            <div className={'page'}>
                <Header/>
                <Dashboard/>
                <Box component="main" sx={{flexGrow: 1, height: '100vh', overflow: 'auto'}}>
                    <Toolbar/>
                    <div className={'main'}>
                        <Button variant="outlined" startIcon={<ChevronLeftIcon/>} onClick={toBack}>
                            {t('back')}
                        </Button>
                        <h2 className={'page-title text-center'}>{pageTitle}</h2>

                        <form onSubmit={saveFormData} encType={'multipart/form-data'}>

                            {/* Yil + Davr — hisobotdagidek */}
                            <div style={{display: 'flex', gap: '16px', marginBottom: '20px', flexWrap: 'wrap', alignItems: 'flex-end'}}>
                                <div style={{display: 'flex', flexDirection: 'column'}}>
                                    <span style={{marginBottom: '4px', fontSize: '14px'}}>{t('report_year')}:</span>
                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                        <DatePicker
                                            minDate={new Date("2022-01-01")}
                                            views={['year']}
                                            label={t('report_year')}
                                            value={year}
                                            onChange={(newValue) => setYear(newValue)}
                                            renderInput={(params) => <TextField {...params} size="small" style={{width: 150}}/>}
                                        />
                                    </LocalizationProvider>
                                </div>

                                <div style={{display: 'flex', flexDirection: 'column'}}>
                                    <span style={{marginBottom: '4px', fontSize: '14px'}}>{t('report_month')}:</span>
                                    <MuiBox sx={{minWidth: 200}}>
                                        <FormControl fullWidth size="small" error={monthError}>
                                            <InputLabel>{t('report_month')}</InputLabel>
                                            <Select
                                                value={month}
                                                label={t('report_month')}
                                                onChange={e => { setMonth(e.target.value); setMonthError(false) }}
                                            >
                                                <MenuItem value={1}>{t('quarter')}</MenuItem>
                                                <MenuItem value={2}>{t('semi_annual')}</MenuItem>
                                                <MenuItem value={3}>{t('nine_month')}</MenuItem>
                                                <MenuItem value={4}>{t('yearly')}</MenuItem>
                                            </Select>
                                            {monthError && (
                                                <span style={{color: '#d32f2f', fontSize: '12px', marginTop: '4px'}}>
                                                    Даврни танланг
                                                </span>
                                            )}
                                        </FormControl>
                                    </MuiBox>
                                </div>
                            </div>

                            {config ? (
                                <TableForm config={config} rows={rows} setRows={setRows}/>
                            ) : (
                                <div style={{marginBottom: 16}}>
                                    <p>
                                        <span className={fileName === '*' ? 'text-danger' : ''}>
                                            {t('take_file')}: {fileName === '*' ? t('section_file_required') : fileName}
                                        </span>
                                        <Button className={'file-upload-btn'} variant="contained" component="label">
                                            {t('take_file')}
                                            <input name={'section_file'} hidden type="file"
                                                   onChange={prepareUpload} title={t('take_file')}/>
                                        </Button>
                                    </p>
                                </div>
                            )}

                            <div style={{marginBottom: 16}}>
                                <textarea
                                    placeholder={t('section_text_placeholder')}
                                    value={text}
                                    onChange={e => setText(e.target.value)}
                                    rows={3}
                                    style={{
                                        width: '100%', padding: '12px 14px',
                                        borderRadius: '4px', border: '1px solid #ccc',
                                        fontSize: '15px', fontFamily: 'inherit',
                                        resize: 'vertical', boxSizing: 'border-box',
                                    }}
                                />
                            </div>

                            <Button type={'submit'} variant="contained" fullWidth color={'info'} size="large">
                                {t('save')}
                            </Button>
                        </form>
                    </div>
                    <Copyright/>
                </Box>
            </div>
        </div>
    )
}

export default connect(props => props.sectionReport, {
    saveSectionReport,
    getAllVerifyResponse,
    messageReset,
})(SectionAdd)